module.exports = __webpack_public_path__ + "assets/img/00094.ddd68ad1.png";